import { render, staticRenderFns } from "./KonvaViewer.vue?vue&type=template&id=4d4d1a6e&scoped=true"
import script from "./KonvaViewer.vue?vue&type=script&lang=js"
export * from "./KonvaViewer.vue?vue&type=script&lang=js"
import style0 from "./KonvaViewer.vue?vue&type=style&index=0&id=4d4d1a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4d1a6e",
  null
  
)

export default component.exports